// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"e487f13b","113":"3013ee84","192":"15c992ed","362":"2a5ff918","462":"ffe85f04","569":"4f2e3675","654":"d3db936e","712":"2d389434","759":"8400ff67","774":"53ae7392","829":"239e6b1a","925":"70d701ac"}[chunkId] + ".chunk.js";
};